import { NavItem } from './nav-item';

export let menu: NavItem[] = [
  {
    displayName: 'Dashboard',
    iconName: 'dashboard',
    route: 'dashboard',
    isActive: 0
  },
  {
    displayName: 'Customer',
    iconName: 'face',
    route: 'customer',
    isActive: 0
  },
  {
    displayName: 'Retailer/PACS',
    iconName: 'assignment',
    route: 'retial-pacs',
    isActive: 0
  },
  {
    displayName: 'Aggregator',
    // iconName: 'engineering',
    iconName: 'person',
    route: 'aggregator',
    isActive: 0
  },
  {
    displayName: 'Auction',
    iconName: 'gavel',
    route: 'auction',
    isActive: 0
  },
  {
    displayName: 'Auction List',
    iconName: 'list',
    route: 'auctionlisting',
    isActive: 0
  },
  {
    displayName: 'BidData',
    iconName: 'forum',
    route: 'biddata',
    isActive: 0
  },
  {
    displayName: 'Report',
    iconName: 'assignment',
    route: 'report',
    isActive: 0,
    children: [
      {
        displayName: 'Participation',
        iconName: 'supervisor_account',
        route: 'report/participation',
        isActive: 0,
      },
      {
        displayName: 'Bidding Report',
        iconName: 'toc ',
        route: 'report/bidlistreport',
        isActive: 0,
      },
      {
        displayName: 'Completed Trades',
        iconName: 'assignment',
        route: 'report/closebidreport',
        isActive: 0,
      }
    ]
  },
  {
    displayName: 'NCCF',
    iconName: 'assignment',
    route: 'nccf',
    isActive: 0,
    children: [
      {
        displayName: 'Listing',
        iconName: 'gavel',
        route: 'nccf/listing',
        isActive: 0,
      },
      {
        displayName: 'Retailer Data',
        iconName: 'feedback',
        route: 'nccf/retailer-distributor',
        isActive: 0
      },
      {
        displayName: 'Nccf Bid Data',
        iconName: 'list',
        route: 'nccf/nccfbiddata',
        isActive: 0
      },
    ]
  },

];
